import { FaTags, FaPercent, FaShippingFast, FaGift } from "react-icons/fa";

export default function OffersHero() {
  return (
    <section className="offers-hero">

      <div className="offers-left">

        <span className="offers-tag">
          LIMITED TIME DEALS
        </span>

        <h1>Special Offers</h1>

        <p>
          Discover exclusive offers on premium paper, packaging boards,
          duplex boards and bulk purchase solutions. Save more with our
          competitive pricing and trusted supply network.
        </p>

        <div className="offers-buttons">

          <a href="#offers" className="offers-btn-primary">
            View Offers
          </a>

          <a href="/contact" className="offers-btn-outline">
            Request Quote
          </a>

        </div>

        <div className="offer-features">

          <div className="offer-feature">
            <FaPercent />
            <span>Bulk Discounts</span>
          </div>

          <div className="offer-feature">
            <FaShippingFast />
            <span>Fast Delivery</span>
          </div>

          <div className="offer-feature">
            <FaGift />
            <span>Exclusive Deals</span>
          </div>

          <div className="offer-feature">
            <FaTags />
            <span>Best Prices</span>
          </div>

        </div>

      </div>

      <div className="offers-right">

        <img
          src="/offer.png"
          alt="Special Offers"
          className="offers-image"
        />

      </div>

    </section>
  );
}